import gql from 'graphql-tag';

export const getDraftContentAppearanceProperty = gql`
	query getDraftContentAppearanceProperty($contentId: ID, $status: [String]) {
		content(id: $contentId, status: $status) {
			nodes {
				id
				appearanceDraft: properties(key: "content-appearance-draft") {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
			}
		}
	}
`;

export const getPublishedContentAppearanceProperty = gql`
	query getPublishedContentAppearanceProperty($contentId: ID, $status: [String]) @SLA {
		content(id: $contentId, status: $status) {
			nodes {
				id
				appearancePublished: properties(key: "content-appearance-published") {
					nodes {
						id
						key
						value
						version {
							number
						}
					}
				}
			}
		}
	}
`;
